import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "markdown-body5" }
const _hoisted_2 = { class: "essay-center" }
const _hoisted_3 = { class: "essay-center-title" }
const _hoisted_4 = { class: "essay-center-img" }
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = ["innerHTML"]

import {
  computed,
  onBeforeUnmount,
  onMounted,
  ref,
} from "vue";
import { useRoute } from "vue-router";
import MarkdownIt from "markdown-it";
import { useBasicLayout } from "@/hooks/useBasicLayout";
import { ai_dictionary_Regexp_list } from "@/views/AIGenerate/smartReading/defaultData";
import { handleDecodeUrlComponentStr } from "@/views/AIGenerate/smartReading/commonMethod";
import { audioPlayStream } from "@/js/common";
import { getBrandImageUrl } from "@/js/brandImages";

import { useToggle } from "@vueuse/core";

interface Props {
  inversion?: boolean;
  error?: boolean;
  text?: string;
  loading?: boolean;
  asRawText?: boolean;
  propWord?: string;
  show?: boolean;
  learnType?: string;
  fontStyle?: Record<string, any>;
  articleText?: string;
  generateType?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TextAnalysis',
  props: {
    inversion: { type: Boolean },
    error: { type: Boolean },
    text: {},
    loading: { type: Boolean },
    asRawText: { type: Boolean },
    propWord: {},
    show: { type: Boolean },
    learnType: {},
    fontStyle: {},
    articleText: {},
    generateType: {}
  },
  emits: ["clear"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

_useCssVars(_ctx => ({
  "eaa147f0": (expandHeight.value)
}))

const emit = __emit;
const props = __props;
const route = useRoute();
const { isMobile } = useBasicLayout();
const gptStr = ref("");
const studentInfo = ref();
const audioPlayer = ref();
const mediaType = ref();

const textRef = ref<HTMLElement>();

const markdownRef2 = ref<any>();
const textBlack = ref<any>();
const bofangIcon = ref<Record<string, string>>({});
const timer = ref(0);
const dicObj = ref<Record<string, any>>({});
const [isExpand, changeIsExpand] = useToggle();
const expandHeight = ref("3rem");
const mdi = new MarkdownIt({
  html: false,
});
mdi.use(function (markdownit) {
  var defaultRender =
    markdownit.renderer.rules.text ||
    function (tokens, idx) {
      return tokens[idx].content;
    };
  markdownit.renderer.rules.text = function (tokens, idx) {
    var html = defaultRender(tokens, idx);
    // 中文开头加标签
    html = html.replace(/^[\u4e00-\u9fa5]+(?=[\s:：（(])/, "<span class='ai-strong'>$&</span>");
    // html = html.replace(/(?<=是)([\u4e00-\u9fa5]+)/g,"<span class='ai-strong'>$&</span>")
    return html;
  };
});

const loading = computed(() => props.loading);

const wrapClass = computed(() => {
  return [
    "text-wrap",
    "min-w-[20px]",
    "rounded-md",
    isMobile.value ? "p-2" : "px-3 py-2",
    props.inversion ? "bg-[#d2f9d1]" : "bg-[#f4f6f8]",
    props.inversion ? "dark:bg-[#a1dc95]" : "dark:bg-[#1e1e20]",
    props.inversion ? "message-request" : "message-reply",
    { "text-red-500": props.error },
  ];
});
const text = computed(() => {
  // 给文章添加标题并首行居中显示
  let value;
  if (props.generateType === "vocabulary") {
    value = props.text ?? "";
  } else {
    value = "# " + (props.text ?? "");
  }
  if (!props.asRawText) {
    return mdi.render(value);
  }
  return value;
});

function getEnByCn(cn: string) {
  const item = ai_dictionary_Regexp_list.find((i) => cn.includes(i.cn));
  if (item) {
    return item.en;
  } else {
    return "";
  }
}

function emitClickEvent(e: any) {
  let target = e.target;
  ai_dictionary_Regexp_list.forEach((item) => {
    if (target.id === `ai-audio-icon-${item.en}` && !loading.value) {
      streamAudioPlay(target.parentElement.innerText.replace(/.*[：|:]/gi, ""), target.id);
    }
  });
}

// 暂停播放
function pauseAudio(id?: string) {
  if (audioPlayer.value) {
    if (mediaType.value === "MEDIA_SOURCE") {
      audioPlayer.value.pause();
      audioPlayer.value = null;
    } else if (mediaType.value === "AUDIO_CONTEXT") {
      audioPlayer.value.close();
      audioPlayer.value = null;
    }
  }
  if (id) {
    bofangIcon.value[id] = "icon-bofang3";
    setElementClass(id, "icon-bofang3");
  } else {
    bofangIcon.value = {};
  }
  clearInterval(timer.value);
}

// 设置播放按钮元素类名
function setElementClass(id: string, value: string) {
  const el = document.querySelector(`#${id}`);
  const classList = el?.classList;
  classList?.remove("icon-bofang3", "icon-bofang2", "icon-bofang1");
  classList?.add(value);
}

// 播放音频
function streamAudioPlay(txt: string, id: string) {
  // 关闭音频
  pauseAudio(id);

  audioPlayStream(txt, (callbackData: any, type: string) => {
    mediaType.value = type;
    let num = 0;
    if (mediaType.value === "MEDIA_SOURCE") {
      audioPlayer.value = new Audio(callbackData);
      audioPlayer.value.oncanplay = function () {
        audioPlayer.value.play();
      };
      audioPlayer.value.onended = function () {
        console.log("ended");
        pauseAudio(id);
      };
      audioPlayer.value.oncanplaythrough = () => {
        console.log("loading");
        clearInterval(timer.value);
        timer.value = window.setInterval(() => {
          num = ++num % 3;
          bofangIcon.value[id] = `icon-bofang${num + 1}`;
          setElementClass(id, `icon-bofang${num + 1}`);
        }, 300);
      };
    } else if (mediaType.value === "AUDIO_CONTEXT") {
      audioPlayer.value = callbackData;
    }
  });
}

function clearFn() {
  emit("clear");
}

function changeExpandFn() {
  changeIsExpand();
  const a = document.querySelector(".essay-center-title");
  if (a) {
    a.classList.remove("expand-class-active");
    if (isExpand.value) {
      a.style.height = a?.scrollHeight + "px";
      expandHeight.value = a?.scrollHeight + "px";
      a.classList.add("expand-class-active");
    } else {
      a.style.height = "3rem";
      expandHeight.value = "3rem";
    }
  }
}

onMounted(() => {
  //获取路由参数
  studentInfo.value = handleDecodeUrlComponentStr(route.params.studentInfo);
  console.log(dicObj.value);
});

onBeforeUnmount(() => {
  pauseAudio();
});

//对外部暴露函数
__expose({
  textBlack,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["text-black", wrapClass.value])
  }, [
    _createElementVNode("div", {
      ref_key: "textRef",
      ref: textRef,
      class: "leading-relaxed break-words"
    }, [
      _createElementVNode("div", {
        ref_key: "textBlack",
        ref: textBlack,
        "scroll-events": true,
        "overflow-scroll": true,
        scroll: true
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _cache[0] || (_cache[0] = _createElementVNode("span", { class: "essay-center-title_label" }, "原文：", -1)),
              _createTextVNode(_toDisplayString(props.propWord), 1)
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("img", {
                class: "essay-center-img_label",
                src: _unref(getBrandImageUrl)('ai_smart_reading/essay_button.svg'),
                alt: "",
                onClick: clearFn
              }, null, 8, _hoisted_5)
            ]),
            _createElementVNode("img", {
              src: _unref(getBrandImageUrl)('ai_smart_reading/arrow.png'),
              class: _normalizeClass(["essay-center-icon", [_unref(isExpand) ? 'expand-class' : 'not-expand-class']]),
              alt: "",
              onClick: changeExpandFn
            }, null, 10, _hoisted_6)
          ]),
          _createElementVNode("div", {
            ref_key: "markdownRef2",
            ref: markdownRef2,
            class: "essay-box",
            innerHTML: text.value
          }, null, 8, _hoisted_7)
        ])
      ], 512)
    ], 512)
  ], 2))
}
}

})